import React from 'react'
import { NumberAxisStyles } from './Style'

const NumberAxis = () => {

    return (
        <NumberAxisStyles>

            <div className='wrap-layout-label'></div>
            <div className='numbers'>
                {[...Array(11)].map((_, index) =>
                    <div>{index * 10}%</div>
                )}
            </div>
        </NumberAxisStyles>
    )
}

export default NumberAxis